import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _SubMacroProcess } from '../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    macroProcess: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SubMarcroProccesEditor = ({ idSelector, macroProcess, onChange, label }: Props) => {

    const subMacroProcess = useDataBean(_SubMacroProcess)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])


    useEffect(() => {
        getLista();
    }, [macroProcess])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        subMacroProcess.instance.getSubProcessCatalog(macroProcess).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Proceso"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDSubProcess} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}